import { useContext } from "react";

import { StoreLocatorContext } from "../../context/StoreLocatorContext";

export const useStoreLocatorContext = () => {
  return useContext(StoreLocatorContext);
};
